import { render } from "./bibliotheque.vue?vue&type=template&id=4e5dd0ca&scoped=true"
import script from "./bibliotheque.vue?vue&type=script&lang=js"
export * from "./bibliotheque.vue?vue&type=script&lang=js"

import "./bibliotheque.vue?vue&type=style&index=0&id=4e5dd0ca&scoped=true&lang=css"

import exportComponent from "C:\\Users\\gaglo\\OneDrive\\Bureau\\top_chronique\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5dd0ca"]])

export default __exports__